import { computed, inject, type MaybeRefOrGetter, provide, toValue } from 'vue';
import {
  type InsightSourcesContext,
  InsightSourcesContextKey,
} from '@/components/home/insights/injectionKeys';
import type { AdpDocument } from '@/types';
import { documentKey } from '@/utils/adpDocument';

export const createInsightSources = (
  sources: MaybeRefOrGetter<AdpDocument[]>,
): InsightSourcesContext => {
  const sourceMap = computed(
    () =>
      new Map(
        toValue(sources).map((document, i) => [
          documentKey(document),
          { document, position: i + 1 },
        ]),
      ),
  );

  return {
    resolveSources: keys =>
      keys
        .map(key => {
          const resolved = sourceMap.value.get(
            documentKey({
              doc_type: key.doc_type,
              id: key.id,
              lang: key.lang,
              publication_office: key.patent_publication_office,
            } as AdpDocument),
          );
          return resolved
            ? { ...resolved, insightSourceId: key.insight_source_id }
            : undefined;
        })
        .filter(source => source !== undefined),
  };
};

export const provideInsightSources = (
  sources: MaybeRefOrGetter<AdpDocument[]>,
) => {
  provide(InsightSourcesContextKey, createInsightSources(sources));
};

export const useInsightSources = (): InsightSourcesContext => {
  const context = inject(InsightSourcesContextKey);
  if (!context) {
    throw new Error(
      'useInsightSources は insight-axis-panel の配下で使用してください',
    );
  }
  return context;
};
